import { compose } from 'redux'

import { callProcedure } from 'core/classes/helpers/callProcedure'

import { IApplyDataChangesFn } from '../../../widgets/assortmentTab/context/models/IApplyDataChangesFn'
import { mapAssortmentGroup } from '../../../widgets/assortmentTab/mappers/mapAssortmentGroup'
import { IAssortmentGroup } from '../models/data/IAssortmentGroup'

interface IAssortmentGroupWithoutEntryId extends Omit<IAssortmentGroup, 'EntryId'> {
  EntryId?: number
}

export const applyAssortmentGroupChanges: IApplyDataChangesFn<IAssortmentGroup> = async (group) => {
  const clone = compose(
    mapAssortmentGroup,
    structuredClone
  )(group) as IAssortmentGroupWithoutEntryId
  try {
    if (clone.EntryId === -1) {
      delete clone.EntryId
    }

    const response = await callProcedure(
      'spJBPAssortmentGroupApplyChanges',
      Object.entries(clone).reduce(
        (acc, entry) => {
          const [key, value] = entry
          acc[`p.${key}`] = value
          return acc
        },
        {} as Record<string, string>
      )
    )

    return response
  } catch (e) {
    return
  }
}
